import {
  useMediaQuery,
  CircularProgress,
  Grid,
  TextField,
  Box,
  Stack,
  Button,
  AppBar,
  InputBase,
  Menu,
  MenuItem,
  Modal,
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  TablePagination,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ClosureFormOne from "./closureform/ClosureFormOne";
import ClosureFormtwo from "./closureform/ClosureFormTwo";
import ClosureFormThree from "./closureform/ClosureFormThree";
import ClosureFormFour from "./closureform/ClosureFormFour";
import ClosureFormFive from "./closureform/ClosureFormFive";
import ClosureFormSix from "./closureform/ClosureFormSix";
import ClosureFormSeven from "./closureform/ClosureFormSeven";
import ClosureFormEight from "./closureform/ClosureFormEight";
import ClosureFormNine from "./closureform/ClosureFormNine";
import ClosureFormTen from "./closureform/ClosureFormTen";
import { API_URL } from "../../Config/api";

const ClosureEvents = ({
  events,
  handleEvent,
  eid,
  handleSubmit,
  readOnly,
}) => {
  const accessToken = localStorage.getItem("token");

  // 1. DATA SAFE EXTRACTION
  let eventData = {};
  if (events) {
    // Agar array aaya toh pehla item lo, varna seedha object lo
    eventData = Array.isArray(events) ? events[0] || {} : events;
  }

  const jobClosureDtl = eventData?.job_closure_dtl || [];

  // Form No extraction (Handling dono cases: agar string/number ho ya array ho)
  let formNo = eventData?.job_cl_fm_no;
  if (Array.isArray(formNo)) {
    formNo = formNo[0];
  }

  // 2. STATES
  const [dtlEvtId, setDtlEvtId] = useState([]);
  const [remarks, setRemarks] = useState([]);
  const [baselineState, setBaseline] = useState([]);
  const [airwayState, setAirway] = useState([]);
  const [breathingState, setBreathing] = useState([]);
  const [circState, setCirc] = useState([]);
  const [skinState, setSkin] = useState([]);
  const [pulseState, setPulse] = useState([]);
  const [tempState, setTemp] = useState([]);
  const [rrState, setRR] = useState([]);
  const [gcsState, setGCS] = useState([]);
  const [spState, setSP] = useState([]);
  const [tbState, setTB] = useState([]);
  const [bpState, setBP] = useState([]);
  const [remark1, setRemark1] = useState([]);

  const [Strength_exer, setStrength_exer] = useState([]);
  const [Stretch_exer, setStretch_exer] = useState([]);
  const [Walk_indep, setWalk_indep] = useState([]);
  const [Walker_stick, setWalker_stick] = useState([]);
  const [remark2, setRemark2] = useState([]);

  const [wound, setWound] = useState([]);
  const [oozing, setOozing] = useState([]);
  const [discharge, setDischarge] = useState([]);
  const [dressing, setDressing] = useState([]);

  const [Nameinjectionfld, setNameinjectionfld] = useState([]);
  const [InjsiteIM, setInjsiteIM] = useState([]);
  const [Dosefreq, setDosefreq] = useState([]);
  const [Remark4, setRemark4] = useState([]);

  const [Catheter_type, setCatheter_type] = useState([]);
  const [Size_catheter, setSize_catheter] = useState([]);
  const [Procedure, setProcedure] = useState([]);
  const [remark5, setRemark5] = useState([]);

  const [remark6, setRemark6] = useState([]);

  const [pulse1, setPulse1] = useState([]);
  const [temp1, setTemp1] = useState([]);
  const [rr1, setRR1] = useState([]);
  const [gcs1, setGCS1] = useState([]);
  const [sp1, setSP1] = useState([]);
  const [tb1, setTB1] = useState([]);
  const [bp1, setBP1] = useState([]);

  const [sutures, setSutures] = useState([]);
  const [staples, setStaples] = useState([]);
  const [dehiWound, setDehiWound] = useState([]);
  const [wound8, setWound8] = useState([]);
  const [remark8, setRemark8] = useState([]);

  const [rtSize, setRTSize] = useState([]);
  const [procedure1, setProcedure1] = useState([]);
  const [remark9, setRemark9] = useState([]);

  useEffect(() => {
    if (jobClosureDtl && jobClosureDtl.length > 0) {
      setDtlEvtId(jobClosureDtl.map((detail) => detail.jcolse_id || ""));
      setRemarks(jobClosureDtl.map((detail) => detail.Remark || ""));

      setBaseline(jobClosureDtl.map((detail) => detail.Baseline || ""));
      setAirway(jobClosureDtl.map((detail) => detail.Airway || ""));
      setBreathing(jobClosureDtl.map((detail) => detail.Breathing || ""));
      setCirc(jobClosureDtl.map((detail) => detail.Circulation || ""));
      setSkin(jobClosureDtl.map((detail) => detail.Skin_Perfusion || ""));
      setPulse(jobClosureDtl.map((detail) => detail.Pulse || ""));
      setTemp(jobClosureDtl.map((detail) => detail.Temp_core || ""));
      setRR(jobClosureDtl.map((detail) => detail.RR || ""));
      setGCS(jobClosureDtl.map((detail) => detail.GCS_Total || ""));
      setSP(jobClosureDtl.map((detail) => detail.SpO2 || ""));
      setTB(jobClosureDtl.map((detail) => detail.TBSL || ""));
      setBP(jobClosureDtl.map((detail) => detail.BP || ""));
      setRemark1(jobClosureDtl.map((detail) => detail.Remark || ""));

      setStrength_exer(
        jobClosureDtl.map((detail) => detail.Strength_exer || ""),
      );
      setStretch_exer(jobClosureDtl.map((detail) => detail.Stretch_exer || ""));
      setWalk_indep(jobClosureDtl.map((detail) => detail.Walk_indep || ""));
      setWalker_stick(jobClosureDtl.map((detail) => detail.Walker_stick || ""));
      setRemark2(jobClosureDtl.map((detail) => detail.Remark || ""));

      setWound(jobClosureDtl.map((detail) => detail.Wound || ""));
      setOozing(jobClosureDtl.map((detail) => detail.Oozing || ""));
      setDischarge(jobClosureDtl.map((detail) => detail.Discharge || ""));
      setDressing(jobClosureDtl.map((detail) => detail.Dressing_status || ""));

      setNameinjectionfld(
        jobClosureDtl.map((detail) => detail.Name_injection_fld || ""),
      );
      setInjsiteIM(jobClosureDtl.map((detail) => detail.Inj_site_IM || ""));
      setDosefreq(jobClosureDtl.map((detail) => detail.Dose_freq || ""));
      setRemark4(jobClosureDtl.map((detail) => detail.Remark || ""));

      setCatheter_type(
        jobClosureDtl.map((detail) => detail.Catheter_type || ""),
      );
      setSize_catheter(
        jobClosureDtl.map((detail) => detail.Size_catheter || ""),
      );
      setProcedure(jobClosureDtl.map((detail) => detail.Procedure || ""));
      setRemark5(jobClosureDtl.map((detail) => detail.Remark || ""));

      setRemark6(jobClosureDtl.map((detail) => detail.Remark || ""));

      setPulse1(jobClosureDtl.map((detail) => detail.Pulse || ""));
      setTemp1(jobClosureDtl.map((detail) => detail.Temp_core || ""));
      setRR1(jobClosureDtl.map((detail) => detail.RR || ""));
      setGCS1(jobClosureDtl.map((detail) => detail.GCS_Total || ""));
      setSP1(jobClosureDtl.map((detail) => detail.SpO2 || ""));
      setTB1(jobClosureDtl.map((detail) => detail.TBSL || ""));
      setBP1(jobClosureDtl.map((detail) => detail.BP || ""));

      setSutures(jobClosureDtl.map((detail) => detail.Sutures_type || ""));
      setStaples(
        jobClosureDtl.map((detail) => detail.Num_Sutures_staples || ""),
      );
      setDehiWound(
        jobClosureDtl.map((detail) => detail.Wound_dehiscence || ""),
      );
      setWound8(jobClosureDtl.map((detail) => detail.Wound || ""));
      setRemark8(jobClosureDtl.map((detail) => detail.Remark || ""));

      setRTSize(jobClosureDtl.map((detail) => detail.Size_RT || ""));
      setProcedure1(jobClosureDtl.map((detail) => detail.Procedure || ""));
      setRemark9(jobClosureDtl.map((detail) => detail.Remark || ""));
    }
  }, [jobClosureDtl]);

  return (
    <Box>
      <Grid container spacing={1}>
        <Grid
          item
          md={12}
          xs={12}
          style={{ height: "480px", overflowY: "scroll" }}
        >
          <Card
            style={{
              background: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              padding: "10px",
              marginTop: "10px",
            }}
          >
            <div>
              <Grid item md={12}>
                <Typography textAlign={"left"} sx={{ marginBottom: "2px" }}>
                  Suffered From: {eventData?.Suffered_from || "N/A"}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <Typography variant="body2" sx={{ color: "gray" }}>
                      Consultant Name:{" "}
                      {eventData?.pt_dtt?.doct_cons_id?.cons_fullname || "N/A"}
                    </Typography>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <Typography variant="body2" sx={{ color: "gray" }}>
                      Consultant Phone:{" "}
                      {eventData?.pt_dtt?.doct_cons_id?.mobile_no || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

             
            

              {jobClosureDtl.length === 0 ? (
                <Card
                  style={{
                    background: "#f9f9f9",
                    boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.1)",
                    borderRadius: "10px",
                    padding: "20px",
                    textAlign: "center",
                    marginTop: "20px",
                  }}
                >
                  <Typography variant="h6" color="textSecondary">
                    All closures are done (No details found)
                  </Typography>
                </Card>
              ) : (
                jobClosureDtl.map((detail, index) => (
                  <Accordion key={index} sx={{ mb: 1 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${index + 1}-content`}
                      id={`panel${index + 1}-header`}
                    >
                      <Grid container spacing={12} alignItems="center">
                        <Grid item>
                          <Typography>Session {index + 1}</Typography>
                        </Grid>
                        <Grid item>
                          <Typography textAlign={"right"}>
                            Date: {detail?.session_date || "N/A"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container>
                        <Grid item md={6} xs={12}>
                          <Typography variant="p" sx={{ color: "gray" }}>
                            Professional Name:{" "}
                            {detail?.prof_name?.prof_name || "N/A"}
                          </Typography>
                          <br />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Typography variant="p" sx={{ color: "gray" }}>
                            Professional Phone:{" "}
                            {detail?.prof_name?.prof_no || "N/A"}
                          </Typography>
                          <br />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Typography variant="p" sx={{ color: "gray" }}>
                            Sub Service Name: {detail?.sub_srv_name || "N/A"}
                          </Typography>
                          <br />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Typography variant="p" sx={{ color: "gray" }}>
                            Added By: {detail?.added_by || "N/A"}
                          </Typography>
                          <br />
                        </Grid>
                      </Grid>

                      {/* FIXED THE FORM SWITCH LOGIC */}
                      <Box mt={2}>
                        {formNo == 1 && (
                          <ClosureFormOne
                            baseline={baselineState[index]}
                            airway={airwayState[index]}
                            skin={skinState[index]}
                            breathing={breathingState[index]}
                            circ={circState[index]}
                            pulse={pulseState[index]}
                            temp={tempState[index]}
                            rr={rrState[index]}
                            gcs={gcsState[index]}
                            sp={spState[index]}
                            tb={tbState[index]}
                            bp={bpState[index]}
                            Remark={remark1[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                            isViewOnly={true}
                          />
                        )}

                        {formNo == 2 && (
                          <ClosureFormtwo
                            events={detail?.hca_jc || []} // <-- FIX: Pass 'hca_jc' array from loop
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}

                        {formNo == 3 && (
                          <ClosureFormThree
                            wound2={wound[index]}
                            oozing2={oozing[index]}
                            discharge2={discharge[index]}
                            dressing2={dressing[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}

                        {formNo == 4 && (
                          <ClosureFormFour
                            Nameinjectionfld1={Nameinjectionfld[index]}
                            InjsiteIM1={InjsiteIM[index]}
                            Dosefreq1={Dosefreq[index]}
                            remark1={Remark4[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}

                        {formNo == 5 && (
                          <ClosureFormFive
                            Cathetertype1={Catheter_type[index]}
                            Sizecatheter1={Size_catheter[index]}
                            Procedure1={Procedure[index]}
                            RemarkN={remark5[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}

                        {formNo == 6 && (
                          <ClosureFormSix
                            remark={remark6[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}

                        {formNo == 7 && (
                          <ClosureFormSeven
                            pulse={pulse1[index]}
                            temp={temp1[index]}
                            rr={rr1[index]}
                            gcs={gcs1[index]}
                            sp={sp1[index]}
                            tb={tb1[index]}
                            bp={bp1[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}

                        {formNo == 8 && (
                          <ClosureFormEight
                            sutures1={sutures[index]}
                            staples1={staples[index]}
                            dehiWound1={dehiWound[index]}
                            wound18={wound8[index]}
                            remark8={remark8[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}

                        {formNo == 9 && (
                          <ClosureFormNine
                            rtSize9={rtSize[index]}
                            procedure9={procedure1[index]}
                            remarkLab={remark9[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}

                        {formNo == 10 && (
                          <ClosureFormTen
                            Strength_exer={Strength_exer[index]}
                            Stretch_exer={Stretch_exer[index]}
                            Walk_indep={Walk_indep[index]}
                            Walker_stick={Walker_stick[index]}
                            remark2={remark2[index]}
                            evtId={dtlEvtId[index]}
                            formNo={formNo}
                            closureStatus={detail?.is_job_closure_done}
                            dtlEventID={detail?.dtl_eve_id}
                            handleEvent={handleEvent}
                            eid={eid}
                          />
                        )}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                ))
              )}
            </div>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClosureEvents;
